module.exports = __webpack_public_path__ + "media/images/one_line_CRM_-_blue_head_red_CRM_logo-bd1ac5cdeec6400a775ab0f5c947ef05.jpg";